var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pdfModal"},[_c('div',{staticClass:"pdfWrapper"},[_c('iframe',{attrs:{"src":this.googleDriveUrl1 + _vm.dataset.url + this.googleDriveUrl2,"width":"100%","height":"200px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }